import React, { useState, useEffect } from 'react';
import FeaturedCatSingle from './FeaturedCatSingle';
import Entities, {XmlEntities} from 'html-entities';
import BlockDisplay from './BlockDisplay';
import { Input, Divider } from 'antd';
 
const entities = new XmlEntities();

function FeaturedCategories({setCodeBlock}) {
  const [heading, setHeading] = useState("Featured Categories");
  const [background, setBackground] = useState("#f9f9f9");
  
  const [firstImage, setFirstImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured01.png");
  const [firstLink, setFirstLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/necklaces/");
  const [firstText, setFirstText] = useState("Necklaces");
  
  const [secondImage, setSecondImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured02.png");
  const [secondLink, setSecondLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/chains-charms-stones/");
  const [secondText, setSecondText] = useState("Chains");
  
  const [thirdImage, setThirdImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured03.png");
  const [thirdLink, setThirdLink] = useState("https://artisan-default-demo.mybigcommerce.com/collections/by-collection/lucky-charms/");
  const [thirdText, setThirdText] = useState("Lucky Charms");
  
  const [fourthImage, setFourthImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured04.png");
  const [fourthLink, setFourthLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/bracelets/");
  const [fourthText, setFourthText] = useState("Bracelets");

  const [fifthImage, setFifthImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured05.png");
  const [fifthLink, setFifthLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/rings/");
  const [fifthText, setFifthText] = useState("Rings");

  const [sixthImage, setSixthImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/featured06.png");
  const [sixthLink, setSixthLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/earrings/");
  const [sixthText, setSixthText] = useState("Earrings");

  const codeBlock = `<div class="featured-categories-wrap" style="background: ${entities.encode(background)};">
  <div class="container">
      <h2 class="page-heading">${entities.encode(heading)}</h2>
      <div class="featured-categories">
          <div><a href="${entities.encode(firstLink)}">
              <img src="${entities.encode(firstImage)}">
              <span>${entities.encode(firstText)}</span>
          </a></div>
          <div><a href="${entities.encode(secondLink)}">
              <img src="${entities.encode(secondImage)}">
              <span>${entities.encode(secondText)}</span>
          </a></div>
          <div><a href="${entities.encode(thirdLink)}">
              <img src="${entities.encode(thirdImage)}">
              <span>${entities.encode(thirdText)}</span>
          </a></div>
          <div><a href="${entities.encode(fourthLink)}">
              <img src="${entities.encode(fourthImage)}">
              <span>${entities.encode(fourthText)}</span>
          </a></div>
          <div><a href="${entities.encode(fifthLink)}">
              <img src="${entities.encode(fifthImage)}">
              <span>${entities.encode(fifthText)}</span>
          </a></div>
          <div><a href="${entities.encode(sixthLink)}">
              <img src="${entities.encode(sixthImage)}">
              <span>${entities.encode(sixthText)}</span>
          </a></div>
      </div>
  </div>
</div>`;

  useEffect(() => {
    setCodeBlock(codeBlock);
  }, [codeBlock]);

  return (
    <div className="singleBlock">
      <div className="sidebar">
        <h2>Featured Categories Block</h2>
        <label>
          <span>Heading</span>
          <Input type="text" value={heading} onChange={(evt) => setHeading(evt.target.value)} />
        </label>

        <label>
          <span>Background Color</span>
          <Input type="color" value={background} onChange={(evt) => setBackground(evt.target.value)} />
        </label>
        
        <Divider />

        <h3>Block 1</h3>
        <FeaturedCatSingle 
          imageValue={firstImage}
          imageText={firstText}
          imageLink={firstLink}
          updateImage={setFirstImage}
          updateText={setFirstText}
          updateLink={setFirstLink}
        />
        
        <Divider />

        <h3>Block 2</h3>
        <FeaturedCatSingle 
          imageValue={secondImage}
          imageText={secondText}
          imageLink={secondLink}
          updateImage={setSecondImage}
          updateText={setSecondText}
          updateLink={setSecondLink}
        />

        <Divider />

        <h3>Block 3</h3>
        <FeaturedCatSingle 
          imageValue={thirdImage}
          imageText={thirdText}
          imageLink={thirdLink}
          updateImage={setThirdImage}
          updateText={setThirdText}
          updateLink={setThirdLink}
        />
        
        <Divider />

        <h3>Block 4</h3>
        <FeaturedCatSingle 
          imageValue={fourthImage}
          imageText={fourthText}
          imageLink={fourthLink}
          updateImage={setFourthImage}
          updateText={setFourthText}
          updateLink={setFourthLink}
        />

        <Divider />

        <h3>Block 5</h3>
        <FeaturedCatSingle 
          imageValue={fifthImage}
          imageText={fifthText}
          imageLink={fifthLink}
          updateImage={setFifthImage}
          updateText={setFifthText}
          updateLink={setFifthLink}
        />

        <Divider />

        <h3>Block 6</h3>
        <FeaturedCatSingle 
          imageValue={sixthImage}
          imageText={sixthText}
          imageLink={sixthLink}
          updateImage={setSixthImage}
          updateText={setSixthText}
          updateLink={setSixthLink}
        />
      </div>
      <BlockDisplay codeBlock={codeBlock}/>
    </div>
  )
}

export default FeaturedCategories;
